/**
 * GLOWRIUM - Main JavaScript
 * Handles all interactive functionality
 */

// EmblaCarousel global access helper
function getEmbla() {
  if (typeof EmblaCarousel !== 'undefined') {
    return EmblaCarousel.default || EmblaCarousel;
  }
  return null;
}

document.addEventListener('DOMContentLoaded', function() {
  initTopBar();
  initHeroCarousel();
  initCategoryCarousel();
  initTabs();
  initVideoShowcase();
  initWhyChooseUs();
  initUgcCarousel();
  initFooterAccordion();
  initSearchOverlay();
  initMobileMenu();
  initNavDropdowns();
  initLucideIcons();
});

/* ============================================
   TopBar scroll animation
   ============================================ */
function initTopBar() {
  const topBarText = document.querySelector('.topbar-scroll-text');
  if (!topBarText) return;
  // Clone text for seamless infinite scroll
  topBarText.innerHTML = topBarText.innerHTML + topBarText.innerHTML;
}

/* ============================================
   HeroBanner Carousel (Embla)
   ============================================ */
function initHeroCarousel() {
  const emblaNode = document.querySelector('.embla-hero');
  if (!emblaNode) return;

  const dotsContainer = document.querySelector('.hero-dots');
  const dots = dotsContainer ? dotsContainer.querySelectorAll('button') : [];

  const Embla = getEmbla();
  if (!Embla) return;
  const emblaApi = Embla(emblaNode, {
    loop: true,
    skipSnaps: false
  });

  // Auto-play every 5 seconds
  let autoplay = setInterval(() => {
    if (!emblaApi.canScrollNext()) {
      emblaApi.scrollTo(0);
    } else {
      emblaApi.scrollNext();
    }
  }, 5000);

  // Update dots on select
  emblaApi.on('select', () => {
    const index = emblaApi.selectedScrollSnap();
    dots.forEach((dot, i) => {
      if (i === index) {
        dot.className = dot.className.replace(/bg-white\/50|bg-white\/80|bg-primary|w-3|w-8/g, '');
        dot.className += ' bg-primary w-8';
      } else {
        dot.className = dot.className.replace(/bg-white\/50|bg-white\/80|bg-primary|w-3|w-8/g, '');
        dot.className += ' bg-white/50 w-3';
      }
    });
  });

  // Dot click navigation
  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      emblaApi.scrollTo(i);
    });
  });

  // Pause autoplay on hover
  const heroSection = document.querySelector('[data-cmp="HeroBanner"]');
  if (heroSection) {
    heroSection.addEventListener('mouseenter', () => clearInterval(autoplay));
    heroSection.addEventListener('mouseleave', () => {
      autoplay = setInterval(() => {
        if (!emblaApi.canScrollNext()) {
          emblaApi.scrollTo(0);
        } else {
          emblaApi.scrollNext();
        }
      }, 5000);
    });
  }
}

/* ============================================
   Category Carousel (Embla)
   ============================================ */
function initCategoryCarousel() {
  const catNode = document.querySelector('.embla-cat');
  if (!catNode) return;

  const Embla = getEmbla();
  if (!Embla) return;
  const emblaApi = Embla(catNode, {
    align: 'start',
    dragFree: true,
    containScroll: 'trimSnaps'
  });

  // Navigation buttons
  const prevBtn = document.querySelector('.cat-prev');
  const nextBtn = document.querySelector('.cat-next');

  function updateCatArrows() {
    if (prevBtn) prevBtn.disabled = !emblaApi.canScrollPrev();
    if (nextBtn) nextBtn.disabled = !emblaApi.canScrollNext();
  }

  if (prevBtn) prevBtn.addEventListener('click', () => emblaApi.scrollPrev());
  if (nextBtn) nextBtn.addEventListener('click', () => emblaApi.scrollNext());

  emblaApi.on('select', updateCatArrows);
  emblaApi.on('reInit', updateCatArrows);
  updateCatArrows();
}

/* ============================================
   Product Tabs + Carousel
   ============================================ */
function initTabs() {
  const tabTriggers = document.querySelectorAll('.tab-trigger');
  const tabPanels = document.querySelectorAll('.tab-panel');

  const Embla = getEmbla();
  if (!Embla) return;

  // Initialize embla instances for each tab
  const emblaInstances = {};
  const prodEmblaNodes = document.querySelectorAll('.embla-prod');
  
  prodEmblaNodes.forEach((node, i) => {
    const tabValue = node.dataset.tab;
    const api = Embla(node, {
      align: 'start',
      dragFree: true,
      containScroll: 'trimSnaps'
    });
    emblaInstances[tabValue] = api;

    // Track arrow state on select/reInit
    api.on('select', updateProdArrows);
    api.on('reInit', updateProdArrows);
  });

  let activeTab = 'trending';

  // Arrow state updater (reads activeTab)
  function updateProdArrows() {
    const api = emblaInstances[activeTab];
    const prevBtn = document.querySelector('.prod-prev');
    const nextBtn = document.querySelector('.prod-next');
    if (api) {
      if (prevBtn) prevBtn.disabled = !api.canScrollPrev();
      if (nextBtn) nextBtn.disabled = !api.canScrollNext();
    }
  }

  // Tab switching
  tabTriggers.forEach(trigger => {
    trigger.addEventListener('click', function() {
      const value = this.getAttribute('data-value');
      
      // Update triggers
      tabTriggers.forEach(t => {
        t.classList.remove('active');
        t.style.backgroundColor = '';
        t.style.color = '';
      });
      this.classList.add('active');
      this.style.backgroundColor = '#002fa7';
      this.style.color = 'white';
      
      // Update panels
      tabPanels.forEach(panel => {
        panel.classList.remove('active');
        if (panel.getAttribute('data-value') === value) {
          panel.classList.add('active');
        }
      });

      activeTab = value;

      // Re-init embla for active tab
      const api = emblaInstances[value];
      if (api) {
        api.reInit();
      }

      // Update arrows after tab switch
      updateProdArrows();
    });
  });

  // Initial arrow state
  updateProdArrows();

  // Navigation buttons
  const prevBtn = document.querySelector('.prod-prev');
  const nextBtn = document.querySelector('.prod-next');
  
  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      const api = emblaInstances[activeTab];
      if (api) api.scrollPrev();
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      const api = emblaInstances[activeTab];
      if (api) api.scrollNext();
    });
  }
}

/* ============================================
   VideoShowcase Scroll Animation
   ============================================ */
function initVideoShowcase() {
  const section = document.querySelector('[data-cmp="VideoShowcase"]');
  if (!section) return;

  const videoOverlay = section.querySelector('.video-overlay');
  const videoText = section.querySelector('.video-text');

  function handleScroll() {
    const rect = section.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const sectionHeight = rect.height;
    const top = rect.top;

    let progress;
    if (top > 0) {
      progress = 0;
    } else if (top < -(sectionHeight - windowHeight)) {
      progress = 1;
    } else {
      progress = Math.abs(top) / (sectionHeight - windowHeight);
    }

    const textProgress = Math.max(0, (progress - 0.1) / 0.9);

    if (videoOverlay) {
      videoOverlay.style.opacity = textProgress * 0.7;
    }
    if (videoText) {
      videoText.style.opacity = textProgress;
      videoText.style.transform = `translateY(${(1 - textProgress) * 40}px)`;
    }
  }

  window.addEventListener('scroll', handleScroll, { passive: true });
  handleScroll();
}

/* ============================================
   WhyChooseUs Selectable Cards
   ============================================ */
function initWhyChooseUs() {
  const cards = document.querySelectorAll('.why-card');
  cards.forEach(card => {
    card.addEventListener('click', function() {
      const isSelected = this.classList.contains('selected');
      // Deselect all
      cards.forEach(c => {
        c.classList.remove('selected');
        c.classList.remove('bg-[#002fa7]/10', 'border-[#002fa7]');
        c.classList.add('border-[#e5e7eb]/50');
        const icon = c.querySelector('.why-card-icon');
        if (icon) icon.classList.remove('text-[#002fa7]');
      });
      // Select clicked if wasn't selected
      if (!isSelected) {
        this.classList.add('selected');
        this.classList.remove('border-[#e5e7eb]/50');
        this.classList.add('bg-[#002fa7]/10', 'border-[#002fa7]');
        const icon = this.querySelector('.why-card-icon');
        if (icon) icon.classList.add('text-[#002fa7]');
      }
    });
  });
}

/* ============================================
   Ugc Video Carousel
   ============================================ */
function initUgcCarousel() {
  const ugcNode = document.querySelector('.embla-ugc');
  if (!ugcNode) return;

  const Embla = getEmbla();
  if (!Embla) return;
  const emblaApi = Embla(ugcNode, {
    align: 'start',
    dragFree: true,
    containScroll: 'trimSnaps'
  });

  const prevBtn = document.querySelector('.ugc-prev');
  const nextBtn = document.querySelector('.ugc-next');

  function updateUgcArrows() {
    if (prevBtn) prevBtn.disabled = !emblaApi.canScrollPrev();
    if (nextBtn) nextBtn.disabled = !emblaApi.canScrollNext();
  }

  if (prevBtn) prevBtn.addEventListener('click', () => emblaApi.scrollPrev());
  if (nextBtn) nextBtn.addEventListener('click', () => emblaApi.scrollNext());

  emblaApi.on('select', updateUgcArrows);
  emblaApi.on('reInit', updateUgcArrows);
  updateUgcArrows();
}

/* ============================================
   Footer Accordion (Mobile)
   ============================================ */
function initFooterAccordion() {
  const toggles = document.querySelectorAll('.footer-toggle');
  toggles.forEach(toggle => {
    toggle.addEventListener('click', function() {
      const panel = this.nextElementSibling;
      const icon = this.querySelector('.footer-chevron');
      
      if (panel.classList.contains('open')) {
        panel.classList.remove('open');
        if (icon) icon.style.transform = 'rotate(0deg)';
      } else {
        panel.classList.add('open');
        if (icon) icon.style.transform = 'rotate(180deg)';
      }
    });
  });
}

/* ============================================
   Search Overlay
   ============================================ */
function initSearchOverlay() {
  const searchToggle = document.querySelector('.search-toggle');
  const searchClose = document.querySelector('.search-close');
  const searchOverlay = document.querySelector('.search-overlay');
  const searchInput = document.querySelector('.search-input');

  if (!searchToggle || !searchOverlay) return;

  searchToggle.addEventListener('click', () => {
    searchOverlay.classList.add('open');
    if (searchInput) setTimeout(() => searchInput.focus(), 100);
    // Hide nav
    const nav = document.querySelector('.desktop-nav');
    if (nav) nav.style.display = 'none';
  });

  if (searchClose) {
    searchClose.addEventListener('click', () => {
      searchOverlay.classList.remove('open');
      if (searchInput) searchInput.value = '';
      const nav = document.querySelector('.desktop-nav');
      if (nav) nav.style.display = '';
    });
  }
}

/* ============================================
   Mobile Menu (Sidebar)
   ============================================ */
function initMobileMenu() {
  const menuBtn = document.querySelector('.mobile-menu-btn');
  const sidebar = document.querySelector('.mobile-sidebar');
  const overlay = document.querySelector('.mobile-overlay');
  const closeBtn = document.querySelector('.mobile-sidebar-close');

  if (!menuBtn || !sidebar || !overlay) return;

  function openMenu() {
    sidebar.classList.add('open');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    sidebar.classList.remove('open');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  menuBtn.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  overlay.addEventListener('click', closeMenu);

  // Collapsible categories in mobile menu
  const mobileToggles = sidebar.querySelectorAll('.mobile-collapse-toggle');
  mobileToggles.forEach(toggle => {
    toggle.addEventListener('click', function() {
      const panel = this.nextElementSibling;
      const icon = this.querySelector('svg');
      if (panel.style.display === 'block') {
        panel.style.display = 'none';
        if (icon) icon.style.transform = 'rotate(0deg)';
      } else {
        panel.style.display = 'block';
        if (icon) icon.style.transform = 'rotate(180deg)';
      }
    });
  });
}

/* ============================================
   Navigation Mega Menu Dropdowns
   ============================================ */
function initNavDropdowns() {
  // Desktop nav items manage their dropdowns via CSS hover
  // This handles touch devices
  const navItems = document.querySelectorAll('.nav-item');
  
  navItems.forEach(item => {
    const dropdown = item.querySelector('.nav-dropdown');
    if (!dropdown) return;

    item.addEventListener('click', function(e) {
      if (window.innerWidth < 1024) return; // Only on desktop

      // Close other dropdowns
      document.querySelectorAll('.nav-dropdown.open').forEach(d => {
        if (d !== dropdown) d.classList.remove('open');
      });

      dropdown.classList.toggle('open');
      e.stopPropagation();
    });
  });

  // Click outside to close
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.nav-item')) {
      document.querySelectorAll('.nav-dropdown.open').forEach(d => {
        d.classList.remove('open');
      });
    }
  });
}

/* ============================================
   Initialize Lucide Icons
   ============================================ */
function initLucideIcons() {
  if (typeof lucide !== 'undefined') {
    lucide.createIcons();
  } else {
    // Retry if not loaded yet
    setTimeout(initLucideIcons, 200);
  }
}

/* ============================================
   Handle window resize for embla carousels
   ============================================ */
window.addEventListener('resize', function() {
  // Embla instances auto-handle resize, but we might need to
  // update CSS custom properties for responsive slide widths
  updateCarouselSizes();
});

function updateCarouselSizes() {
  const width = window.innerWidth;
  const root = document.documentElement;

  // Category carousel sizes
  if (width < 640) {
    root.style.setProperty('--cat-slide-size', '28%');
    root.style.setProperty('--cat-spacing', '0.5rem');
    root.style.setProperty('--prod-slide-size', '60%');
    root.style.setProperty('--prod-spacing', '1rem');
    root.style.setProperty('--ugc-slide-size', '60%');
    root.style.setProperty('--ugc-spacing', '1rem');
  } else if (width < 768) {
    root.style.setProperty('--cat-slide-size', '22%');
    root.style.setProperty('--cat-spacing', '1rem');
    root.style.setProperty('--prod-slide-size', '45%');
    root.style.setProperty('--prod-spacing', '1.5rem');
    root.style.setProperty('--ugc-slide-size', '40%');
    root.style.setProperty('--ugc-spacing', '1rem');
  } else if (width < 1024) {
    root.style.setProperty('--cat-slide-size', '16.66%');
    root.style.setProperty('--cat-spacing', '1rem');
    root.style.setProperty('--prod-slide-size', '33.33%');
    root.style.setProperty('--prod-spacing', '1.5rem');
    root.style.setProperty('--ugc-slide-size', '33.33%');
    root.style.setProperty('--ugc-spacing', '1rem');
  } else {
    root.style.setProperty('--cat-slide-size', '12.5%');
    root.style.setProperty('--cat-spacing', '1rem');
    root.style.setProperty('--prod-slide-size', '25%');
    root.style.setProperty('--prod-spacing', '1.5rem');
    root.style.setProperty('--ugc-slide-size', '25%');
    root.style.setProperty('--ugc-spacing', '1rem');
  }
}

// Initialize sizes on load
updateCarouselSizes();
